type EventSeoSchemaProps = {
  title: string
  description?: string
  imageUrl?: string
  startDate?: string
  endDate?: string
  locationName?: string
  dataTestId?: string
  contributors?: Array<{name: string}>
}

export const EventSeoSchema = ({
  title,
  imageUrl,
  startDate,
  endDate,
  locationName,
  dataTestId,
  contributors,
}: EventSeoSchemaProps) => {
  const imageLinks = imageUrl
    ? [
        `https:${imageUrl}?w=2560&h=1440&fm=webp`,
        `https:${imageUrl}?w=1280&h=960&fm=webp`,
        `https:${imageUrl}?w=1000&h=1000&fm=webp`,
      ]
    : undefined

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: title,
    image: imageLinks,
    startDate,
    endDate,
    contributor: contributors && contributors.map(c => ({'@type': 'Person', name: c.name})),
    location: locationName
      ? {
          '@type': 'Place',
          name: locationName,
        }
      : undefined,
    organizer: {
      '@type': 'Organization',
      name: 'GitHub',
      url: 'https://www.github.com',
    },
  }

  const jsonLd = JSON.stringify(structuredData)

  /* eslint-disable-next-line react/no-danger */
  return <script data-testid={dataTestId} type="application/ld+json" dangerouslySetInnerHTML={{__html: jsonLd}} />
}
